module.exports = __webpack_public_path__ + "img/conny-f-stage7-blink.46fdac48.png";